import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GUIDES } from "../lib/guides";
import { useGuideTranslations } from "../pages/GuidePage";
import { lp } from "../lib/urls";

const HEAD = {
  en: { k: "Undercarriage_Knowledge", t: "Expert guides from our engineers", min: "Min Read" },
  de: { k: "Fahrwerk_Wissen", t: "Fachratgeber unserer Ingenieure", min: "Min. Lesezeit" },
  es: { k: "Conocimiento_Tren_De_Rodaje", t: "Guías técnicas de nuestros ingenieros", min: "Min de lectura" },
  it: { k: "Conoscenza_Sottocarro", t: "Guide tecniche dei nostri ingegneri", min: "Min di lettura" },
  pt: { k: "Conhecimento_Material_Rodante", t: "Guias técnicos dos nossos engenheiros", min: "Min de leitura" },
  fr: { k: "Savoir_Train_De_Roulement", t: "Guides techniques de nos ingénieurs", min: "Min de lecture" },
  nl: { k: "Rijwerk_Kennis", t: "Technische gidsen van onze ingenieurs", min: "Min leestijd" },
  ru: { k: "Знания_о_ходовой_части", t: "Технические руководства наших инженеров", min: "мин чтения" },
  lt: { k: "Važiuoklės_žinios", t: "Mūsų inžinierių techniniai gidai", min: "min skaitymo" },
};

export const TYPE_GUIDES = {
  "track-chain": ["track-chain-wear-guide", "pin-and-bushing-turn", "how-to-adjust-track-tension"],
  "track-group": ["track-chain-wear-guide", "track-shoe-selection-guide", "undercarriage-replacement-cost-guide"],
  "track-roller": ["undercarriage-inspection-checklist", "undercarriage-wear-chart-measurement", "extend-undercarriage-life"],
  "carrier-roller": ["undercarriage-inspection-checklist", "track-alignment-problems", "undercarriage-maintenance-schedule"],
  "track-shoe": ["track-shoe-selection-guide", "dozer-vs-excavator-undercarriage", "extend-undercarriage-life"],
  idler: ["track-alignment-problems", "thrown-track-causes-prevention", "undercarriage-inspection-checklist"],
  sprocket: ["sprocket-wear-guide", "track-chain-wear-guide", "undercarriage-wear-chart-measurement"],
  "rubber-track": ["rubber-tracks-vs-steel-tracks", "mini-excavator-undercarriage-guide", "thrown-track-causes-prevention"],
  "rubber-pad": ["rubber-tracks-vs-steel-tracks", "track-shoe-selection-guide", "mini-excavator-undercarriage-guide"],
  "track-bolt-nut": ["undercarriage-inspection-checklist", "undercarriage-maintenance-schedule", "track-shoe-selection-guide"],
};

const DEFAULT_GUIDES = [
  "undercarriage-inspection-checklist",
  "track-chain-wear-guide",
  "undercarriage-replacement-cost-guide",
];

export const RelatedGuides = ({ typeSlug, slugs: slugsProp }) => {
  const { i18n } = useTranslation();
  const dict = useGuideTranslations();
  const lang = (i18n.language || "en").slice(0, 2);
  const h = HEAD[lang] || HEAD.en;
  const slugs = slugsProp || TYPE_GUIDES[typeSlug] || DEFAULT_GUIDES;
  return (
    <section
      className="bg-gray-50 border-b border-border p-6 sm:px-14 sm:py-10"
      data-testid="related-guides"
    >
      <p className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-gray-500 mb-4">
        {h.k}
      </p>
      <div className="grid sm:grid-cols-3 gap-px bg-border border border-border max-w-5xl">
        {slugs.map((s) => {
          const g = dict?.[s] || GUIDES[s];
          if (!g) return null;
          return (
            <Link
              key={s}
              to={lp(`/guides/${s}`)}
              data-testid={`related-guide-${s}`}
              className="cell-hover bg-white p-5 flex flex-col justify-between gap-3 min-h-[120px]"
            >
              <span className="font-semibold text-sm text-gray-950 leading-snug">
                {g.title}
              </span>
              <span className="font-mono-tech text-[9px] uppercase tracking-[0.2em] text-gray-400">
                {GUIDES[s].minutes} {h.min} →
              </span>
            </Link>
          );
        })}
      </div>
      <p className="mt-3 font-mono-tech text-[10px] uppercase tracking-[0.15em] text-gray-500">
        {h.t}
      </p>
    </section>
  );
};
